import React, {useEffect, useRef} from "react";
import "./Top.scss";

export default function Top() {
  const btnRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      const el = btnRef.current;
      if (!el) return;
      const scrolled =
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20;
      el.style.visibility = scrolled ? "visible" : "hidden";
    };

    onScroll();
    window.addEventListener("scroll", onScroll, {passive: true});
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <button ref={btnRef} onClick={toTop} id="topButton" title="Go to top">
      <i className="fas fa-hand-point-up" aria-hidden="true"></i>
    </button>
  );
}
